import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { workActivityActions } from '../../../application/actions/workActivity';

import api from '../../api';

const apiWorkAcitvity = api(process.env.REACT_APP_WORK_ACTIVITY_API);

export function* fetchWorkActivity() {
  try {
    const { data } = yield call(apiWorkAcitvity.get, 'v1/consultar');

    if (data) yield put(workActivityActions.fetchWorkActivitySuccess({ workActivity: data.items }));
    else yield put(workActivityActions.fetchWorkActivityError());
  } catch (err) {
    yield put(workActivityActions.fetchWorkActivityError());
  }
}

export function* watchFetchWorkActivity() {
  yield takeLatest(workActivityActions.fetchWorkActivity.type, fetchWorkActivity);
}
 /* istanbul ignore next */
export default function* workActivitySaga() {
  yield spawn(watchFetchWorkActivity);
}
